import _ from 'lodash';
import vxPagination from '../vx-pagination/vx-pagination.vue';

/*
POINTS TO REMEMBER
1. Fields of configuration(tableConfig.columnConfiguration)
  {
    field: string,
    customHeaderName: string (mandatory),
    customTemplate: function/ES6 function if using 'this',
    visibilityCondition: function/ES6 function if using 'this',
    emptyTable: string (message to display when there is no data in table),
  }
2. if using 'this' context inside the configuation always use es6 or arrow function
3. visibilityCondition is for conditionally deciding if a particular column must be visible
4. tableConfig also takes a field rowCount apart from columnConfiguration.
    The rowCount defines the number of rows of data visible per page.
5. if emptyTable field is not provided/configured, the default message is shown
6. field data can be simple or nested fields delimited by dots, the field data will not be considered if customemplate field is provided

*/


export default {
  name: 'vx-table',
  components: {
    vxPagination,
  },
  props: {
    msg: String,
    tableConfig: {
      Type: Object,
      default: null,
    },
    tableData: {
      Type: Array,
      default: [],
    },
  },
  data() {
    return {
      resultantColumnConfiguration: [],
      constructedTableData: [],
      currentPage: 1,
      pageSize: 1,
    };
  },
  methods: {
    constructTableData() {
      if (this.tableData !== null || this.tableData.length) {
        this.getDatainRange(0, this.tableConfig.rowCount);
      }
    },
    /*
      getDatainRange gets the data between start and end with start inclusive
    */
    getDatainRange(start, end) {
      const resultantData = [];
      this.constructedTableData = [];

      // we try to filter-out the columns we need not display before gathering data
      this.eliminateUnwantedColumns();

      for (let i = start; i < end; i++) {
        const data = [];
        if (this.tableData[i]) {
          this.resultantColumnConfiguration.forEach((configObject) => {
            // check if customTemplate has been provided in the configuration, if yes then execute the function and add the result to the data array
            if (configObject.hasOwnProperty('customTemplate')) {
              const template = configObject.customTemplate(this.tableData[i]);
              data.push({ customTemplate: template });

              // if the field has a value (simple field or nested field) then pick that value and push it to the data array
            } else if (configObject.hasOwnProperty('field')) {
              let field = null;
              if (Array.isArray(configObject.field)) {
                field = configObject.field;
              } else {
                // for dot de-limited nested field
                field = configObject.field.split('.');
              }
              const temp_data = _.get(this.tableData[i], field, '');
              data.push(temp_data);
            } else {
              data.push('');
            }
          });
          resultantData.push(data);
        } else {
          break;
        }
      }
      this.constructedTableData = resultantData;
    },
    handlePaginationClick(pageNumber) {
      // sync current page between pagination and table
      this.currentPage = pageNumber;
      this.getDatainRange((pageNumber - 1) * this.tableConfig.rowCount, ((pageNumber - 1) * this.tableConfig.rowCount) + this.tableConfig.rowCount);
    },
    /*
      this function basically filters that needs to be displayed based on visibilityCondition configuration provided.
     */
    eliminateUnwantedColumns() {
      if (_.get(this.tableConfig, 'columnConfiguration', null) !== null) {
        this.resultantColumnConfiguration = [];
        this.tableConfig.columnConfiguration.forEach((configObject) => {
          const visibilityCondition = _.get(configObject, 'visibilityCondition', null);
          if (visibilityCondition === null || (typeof visibilityCondition === 'function' && visibilityCondition.call() === true)) {
            this.resultantColumnConfiguration.push(configObject);
          }
        });
      }
    },
    sortColumn(columnIndex) {
      console.log(columnIndex);
    },
  },
  async mounted() {
    this.constructTableData();
  },
  watch: {
    tableData() {
      /*
        if data loads asynchronously we use this watch to watch for the data to load and then load table
      */
      this.constructTableData();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-table/vx-table.js